module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"progress":"Bewertungsfortschritt","thanks":{"title":"Vielen Dank!","content":"Ihre Bewertung ist vollständig."}},"en":{"progress":"Evaluation progress","thanks":{"title":"Thank you!","content":"Your evaluation is complete."}}}')
  delete Component.options._Ctor
}
